@if (isEditMode) {
  <div class="table-content" title="{{cellValue}}">
    <input autocomplete="off" type="text" class="form-control fn-input" [(ngModel)]="cellValue" fnNumberDirective [disabled]="isDisable" (changeEvent)="changeAction($event)" (blur)="blurAction()"
      (focus)="focusAction()" />
    </div>
  }
  @if (!isEditMode) {
    <div class="table-content cursor-pointer" title="{{cellValue}}" (dblclick)="dbClickAction()">
      {{cellValue}}
    </div>
  }
